<template>
  <header class="header">
    <div class="container">
      <router-link to="/">
        <img
          class="logo"
          src="../../assets/img/logo.png"
          alt="Logo"
        />
      </router-link>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
};
</script>

<style lang="scss" scoped>
.header {
  padding:1.5rem 0;
  .logo {
    max-width:100%;
  }
}
</style>
